"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatTrappers = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var HeatTrappers = (function (_super) {
    __extends(HeatTrappers, _super);
    function HeatTrappers() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.HEAT_TRAPPERS,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.BUILDING],
            cost: 6,
            metadata: {
                cardNumber: '178',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().heat(2, { all: Options_1.all }).br;
                        pb.plus().energy(1);
                    });
                }),
                description: 'Decrease any heat production 2 steps and increase your Energy production 1 step.',
                victoryPoints: -1,
            },
        }) || this;
    }
    HeatTrappers.prototype.canPlay = function (player) {
        return player.game.someoneHasResourceProduction(Resources_1.Resources.HEAT, 2);
    };
    HeatTrappers.prototype.produce = function (player) {
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.HEAT, 2));
        player.addProduction(Resources_1.Resources.ENERGY, 1);
    };
    HeatTrappers.prototype.play = function (player) {
        this.produce(player);
        return undefined;
    };
    HeatTrappers.prototype.getVictoryPoints = function () {
        return -1;
    };
    return HeatTrappers;
}(Card_1.Card));
exports.HeatTrappers = HeatTrappers;
